import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import Header from "./gapsy-header";
import Navigation from "./gapsy-Cnavigation";
import Footer from "./gapsy-footer";
import styles from "../assets/css/gapsy-dashboard.module.css";
import tableStyles from "../assets/css/sharedTableStyles.module.css";
import { uploadMutiple, Bulkuploaddata, previewrdmdata, shariahmappingdata, checkboxrejectpastdata, checkboxapprove, updatetextfile3001 } from '../components/ApiProperty';
import { Modal, Button } from 'react-bootstrap';
import {  Rejectcolor, submitButtonStyle, cancelButtonStyle, ProceedButtonStyle } from "../components/Propertyfile";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import GapsyShariahDescription from "../components/GapsyShariahDescription";



const GapsyShariahReviewRetrieval = () => {
    const [sheetData, setSheetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [indexRows, setIndexRows] = useState([]);
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showNotifyModal, setShowNotifyModal] = useState(false);
    const [operationalRiskCharge, setOperationalRiskCharge] = useState("");
    const [tempData, setTempData] = useState([]);
    const [liveData, setLiveData] = useState([]);
    const [makerRemarks, setMakerRemarks] = useState("");
    const [showReportingModal, setShowReportingModal] = useState(false);
    const [reportingMessage, setReportingMessage] = useState("");
    const [allowSubmit, setAllowSubmit] = useState(true);
    const [isViewMode, setIsViewMode] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [showConfirmApprove, setShowConfirmApprove] = useState(false);
    const [rejectedReason, setRejectedReason] = useState("");
    const [showDownload, setShowDownload] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [q1, setQ1] = useState("");
    const [reportingDates, setReportingDates] = useState([]);
    const [q2, setQ2] = useState("");
    const [q3, setQ3] = useState("");
    const [reportingDate, setReportingDate] = useState("");
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const userId = localStorage.getItem("userid");
    const department = sessionStorage.getItem("dept");
    const [initialIndexRows, setInitialIndexRows] = useState([]);
    const [initialGradeRows, setInitialGradeRows] = useState([]);
    const [gradeRows, setGradeRows] = useState([]);
    const [excelLoaded, setExcelLoaded] = useState(false);


    useEffect(() => { loadExcel(); }, []);

    const fmt = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            if (val > 0 && val < 1) return (val * 100).toFixed(0) + "%";
            return val.toLocaleString("en-US", { maximumFractionDigits: 2 });
        }
        return String(val);
    };

    useEffect(() => {
        fetchPreviewData();
    }, []);

    const loadReportingDateData = async (quarter) => {

        if (!quarter) {
            handleReset();
            setMakerRemarks("");
            setIsEditMode(true);
            setIsViewMode(false);
            return;
        }

        const reportDate = getReportingDate(quarter);

        // Get mapping API data
        const mappingData = (await loadShariahMapping(reportDate)) || [];

        console.log("mappingData length:", mappingData.length);
        console.log(mappingData);

        const hasMapping = mappingData.length > 0;

        console.log("mappingData length:", mappingData.length);
        console.log(mappingData);

        if (!hasMapping) {
            restoreExcelValues();
        }

        // Get temp records
        const records = tempData.filter(
            row =>
                row.reporting_date === reportDate &&
                isNullValue(row.Rejected_Reason)
        );

        handleReset();

        if (records.length === 0) {
            setMakerRemarks("");
            setIsViewMode(false);
            return;
        }

        // Quarter values
        const first = records[0];

        setQ1(first.quarter1 === "\\N" ? "" : first.quarter1);
        setQ2(first.quarter2 === "\\N" ? "" : first.quarter2);
        setQ3(first.quarter3 === "\\N" ? "" : first.quarter3);

        const remarks =
            records.find(r => !isNullValue(r.Maker_Remarks))?.Maker_Remarks || "";

        setMakerRemarks(remarks);

        // Operational Risk Charge
        const chargeRow = records.find(r =>
            (r.particulars || "").includes("Operational Risk")
        );

        if (chargeRow) {
            setOperationalRiskCharge(
                chargeRow.amount === "\\N" ? "" : chargeRow.amount
            );
        }

        // -----------------------------
        // Update Index Rows
        // -----------------------------
        const updatedRows = initialIndexRows.map(row => {

            const mapRow = hasMapping
                ? mappingData.find(
                    m => (m.key_area || "").trim() === row.keyArea.trim()
                )
                : null;

            const dbRow = records.find(
                r => (r.key_areas || "").trim() === row.keyArea.trim()
            );

            return {
                ...row,

                // From Mapping API
                weight: mapRow
                    ? Number(mapRow.weight) / 100
                    : row.weight,

                weightDisplay: mapRow?.weight,

                // From Temp Table
                observations:
                    dbRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b === "\\N"
                        ? ""
                        : dbRow?.no_of_observations_issues_non_compliance_delays_self_assesment_b || "",

                impact:
                    dbRow?.impact_scale_of_1_to_10_c === "\\N"
                        ? ""
                        : dbRow?.impact_scale_of_1_to_10_c || "",

                index:
                    dbRow?.index_a_b_c === "\\N"
                        ? 0
                        : Number(dbRow?.index_a_b_c || 0)
            };
        });

        setIndexRows(updatedRows);

        // -----------------------------
        // Update Grade Rows
        // -----------------------------

        console.log("Excel Grade Rows:", initialGradeRows);
        console.log("Mapping Data:", mappingData);

        const gradeMapping = mappingData.filter(item => item.score_grade);

        const updatedGradeRows = initialGradeRows.map((row, index) => {
            const match = gradeMapping[index];

            if (!match) return row;

            return {
                ...row,
                scoreGrade: match.score_grade,
                min: Number(match.min),
                max: Number(match.max),
                percentage: Number(match.percentage) / 100,
            };
        });

        setGradeRows(updatedGradeRows);
        // setGradeRows(updatedGradeRows);

        // Read only mode
        setIsViewMode(true);
    };

    useEffect(() => {

        if (excelLoaded && reportingDate) {
            loadReportingDateData(reportingDate);
        }

    }, [excelLoaded, reportingDate]);

    const fetchTableData = async (tableName) => {

        const config = {
            headers: {
                userId: localStorage.getItem("userid"),
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                tableName,
                dataModel: "DEM",
            },
        };

        // Get JSON filename
        const apiResponse = await axios.post(previewrdmdata, {}, config);

        if (!apiResponse.data?.fileName) {
            throw new Error(`No data file available for ${tableName}`);
        }

        const fetchedFileName = apiResponse.data.fileName;

        // Fetch JSON
        const dataResponse = await fetch(`/jsonfiles/${fetchedFileName}`);

        if (!dataResponse.ok) {
            throw new Error(`Failed to load ${fetchedFileName}`);
        }

        const jsonData = await dataResponse.json();

        return {
            fileName: fetchedFileName,
            data: jsonData
        };
    };

    const fetchPreviewData = async () => {
        try {

            const [tempResult, liveResult] = await Promise.all([
                fetchTableData("Risk_shariah_pillar1_retrieved"),
                fetchTableData("Risk_shariah_pillar1_live")
            ]);

            setTempData(tempResult.data);
            setLiveData(liveResult.data);

            const dates = [
                ...new Set(
                    tempResult.data
                        .map(row => getQuarterFromReportingDate(row.reporting_date))
                        .filter(Boolean)
                )
            ];

            setReportingDates(dates);
        } catch (err) {
            console.error("Preview Fetch Error:", err);
        }
    };

    const str = (c) => (c == null ? "" : String(c).trim());

    const isNullValue = (value) => {
        if (value == null) return true;

        const v = String(value).trim().toUpperCase();

        return (
            v === "" ||
            v === "\\N" ||
            v === "N" ||
            v === "//N" ||
            v === "NULL"
        );
    };

    const loadShariahMapping = async (reportDate) => {
        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    dept: department,
                    tableName: "Shariah",
                    reportingDate: reportDate
                }
            };

            const response = await axios.post(
                shariahmappingdata,
                {},
                config
            );

            return response.data.data || [];

        } catch (err) {
            console.error(err);
            return [];
        }
    };

    const handleCancel = () => {
        restoreExcelValues();
        if (messageType === "success") {
            // setReportingDate("");
            // handleReset();
            setIsEditMode(false);
            setMakerRemarks("");
            setIsViewMode(true);
        }

        setShowModal(false);
        setModalMessage("");
    };

    const loadExcel = async () => {
        try {
            const response = await fetch("/templates/sharaiah_template_sheet.xlsx");
            if (!response.ok) throw new Error("Unable to load Excel file.");

            const data = await response.arrayBuffer();
            // const workbook = XLSX.read(data, { type: "array" });
            const workbook = XLSX.read(data, {
                type: "array",
                cellText: true
            });
            const sheetName = "Shariah Risk (P 2) - Dec 25";
            const worksheet = workbook.Sheets[sheetName];
            if (!worksheet) { alert(`${sheetName} sheet not found`); return; }

            const rows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: null,
                raw: true
            });

            // ── Helper: find the first row index where col1 matches a predicate ──
            const findRow = (predicate, from = 0) => {
                for (let i = from; i < rows.length; i++) {
                    const row = rows[i] || [];
                    if (predicate(row, i)) return i;
                }
                return -1;
            };

            const c1 = (row) => str(row[1]);

            // ── Locate landmark rows by content ──
            const iRow = findRow(r => r[0] === 1 && c1(r).toLowerCase().includes("name of risk"));
            const iSec2 = findRow(r => r[0] === 2);
            const iDefLabel = findRow(r => c1(r).toLowerCase().startsWith("definition"));
            const iSec3 = findRow(r => r[0] === 3 && c1(r).toLowerCase().includes("key areas"));
            const iSec4 = findRow(r => r[0] === 4 && c1(r).toLowerCase().includes("risk measurement"));
            const iIntro = findRow(r => c1(r).toLowerCase().includes("keeping in view"), iSec4);
            const iTableTitle = findRow(r => c1(r).toLowerCase().includes("computation of shariah"), iSec4);
            const iPeriod = findRow(r => c1(r).toLowerCase().startsWith("period"), iSec4);
            const iIdxHdr = findRow(r => c1(r).toLowerCase() === "key areas" && r[0] === null, iTableTitle);
            // const iTotalRow = findRow(r => (r[1] === null || r[1] === undefined || str(r[1]) === "") && typeof r[2] === "number", iIdxHdr + 1);
            const iTotalRow = findRow(
                r => {
                    const label = str(r[1]).toLowerCase();

                    return (
                        label.includes("total") ||
                        (label === "" && typeof r[2] === "number")
                    );
                },
                iIdxHdr + 1
            );
            const iGradeHdr = findRow(r => c1(r).toLowerCase() === "score grade", iTotalRow);
            const iPartHdr = findRow(r => c1(r).toLowerCase() === "particulars", iGradeHdr);
            const iQuarterHdr = findRow(r => [r[1], r[2], r[3], r[4]].some(c => /^Q\d-\d{4}$/i.test(str(c))), iPartHdr);
            const iQuarterVal = findRow(r => [r[1], r[2], r[3], r[4]].every(c => typeof c === "number"), iQuarterHdr + 1);
            const iFinalCap = findRow(r => c1(r).toLowerCase().includes("final capital charge"), iQuarterVal);

            // ── Extract each section ──

            // 1. Name of risk
            const rowNameOfRisk = rows[iRow] || [];
            const nameOfRisk = str(rowNameOfRisk[3]) || str(rowNameOfRisk[2]) || "";

            // 2. Summary
            const summary = iSec2 >= 0 ? c1(rows[iSec2]) : "";

            // 3. Definition
            const definition = iDefLabel >= 0 ? c1(rows[iDefLabel]) : "";
            const defTextRow = iDefLabel >= 0 ? findRow(r => c1(r).length > 10, iDefLabel + 1) : -1;
            const definitionText = defTextRow >= 0 ? c1(rows[defTextRow]) : "";

            // 4. Pillar
            const iPillar = findRow(r => c1(r).toUpperCase().includes("PILLAR"));
            const pillar = iPillar >= 0 ? c1(rows[iPillar]) : "";

            // 5. Key areas
            const keyAreasIntroRow = findRow(r => c1(r).toLowerCase().includes("the bank considers"), iSec3);
            const keyAreasIntro = keyAreasIntroRow >= 0 ? c1(rows[keyAreasIntroRow]) : "";
            const keyAreas = [];
            const keyEnd = iSec4 >= 0 ? iSec4 : rows.length;
            for (let i = (keyAreasIntroRow >= 0 ? keyAreasIntroRow + 1 : iSec3 + 1); i < keyEnd; i++) {
                const txt = c1(rows[i]);
                if (txt.length > 10) keyAreas.push(txt);
            }

            // 6. Risk measurement
            const heading = iSec4 >= 0 ? c1(rows[iSec4]) : "";
            const intro = iIntro >= 0 ? c1(rows[iIntro]) : "";
            const tableTitle = iTableTitle >= 0 ? c1(rows[iTableTitle]) : "";
            const period = iPeriod >= 0 ? c1(rows[iPeriod]) : "";

            // Index table headers (cols 1,2,3,5,7 — skip merged empty cols)
            const indexHeaders = iIdxHdr >= 0
                ? [rows[iIdxHdr][1], rows[iIdxHdr][2], rows[iIdxHdr][3], rows[iIdxHdr][5], rows[iIdxHdr][7]]
                    .map(h => str(h).replace(/\n/g, " "))
                : [];

            // setIndexRows(indexRows);
            const parsedIndexRows = [];

            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {
                    const r = rows[i];

                    if (c1(r).length > 0) {
                        parsedIndexRows.push({
                            keyArea: str(r[1]),
                            weight: Number(r[2]) || 0,
                            observations: "",
                            impact: "",
                            index: 0
                        });
                    }
                }
            }

            setIndexRows(parsedIndexRows);
            setInitialIndexRows(parsedIndexRows.map(row => ({ ...row })));
            // Index table data rows (between header and total row)
            const indexRows = [];
            if (iIdxHdr >= 0 && iTotalRow >= 0) {
                for (let i = iIdxHdr + 1; i < iTotalRow; i++) {
                    const r = rows[i];
                    if (c1(r).length > 0) {
                        // indexRows.push([str(r[1]), r[2], r[3], r[5], r[7]]);
                        indexRows.push({
                            keyArea: str(r[1]),
                            weight: Number(r[2]) || 0,   // A
                            observations: "",            // B (editable)
                            impact: "",                  // C (editable)
                            index: 0                     // A * B * C
                        });
                    }
                }
            }

            // Index total row
            const indexTotal = iTotalRow >= 0
                ? { weight: rows[iTotalRow][2], index: rows[iTotalRow][7] }
                : null;

            // Grade table headers (cols 1,2,3,4,6 — skip merged col 5)
            const gradeHeaders = iGradeHdr >= 0
                ? [rows[iGradeHdr][1], rows[iGradeHdr][2], rows[iGradeHdr][3], rows[iGradeHdr][4], rows[iGradeHdr][6]]
                    .map(h => str(h))
                : [];

            // Grade rows (between grade header and particulars header)
            const parsedGradeRows = [];

            if (iGradeHdr >= 0 && iPartHdr >= 0) {
                for (let i = iGradeHdr + 1; i < iPartHdr; i++) {
                    const r = rows[i];

                    if (c1(r).length > 0) {
                        parsedGradeRows.push({
                            scoreGrade: str(r[1]),
                            min: Number(r[2]) || 0,
                            max: Number(r[3]) || 0,
                            percentage: Number(r[4]) || 0,
                            applicablePercentage: 0
                        });
                    }
                }
            }
            setGradeRows(parsedGradeRows);
            setInitialGradeRows(
                parsedGradeRows.map(row => ({ ...row }))
            );

            // Particulars rows (between particulars header and quarter header)
            const particularsRows = [];
            if (iPartHdr >= 0 && iQuarterHdr >= 0) {
                for (let i = iPartHdr + 1; i < iQuarterHdr; i++) {
                    const r = rows[i];
                    if (c1(r).length > 0) {
                        particularsRows.push({ label: c1(r), amount: r[3] });
                    }
                }
            }

            // Quarter headers and values
            const quarterHeaders = iQuarterHdr >= 0
                ? [rows[iQuarterHdr][1], rows[iQuarterHdr][2], rows[iQuarterHdr][3], rows[iQuarterHdr][4]].map(str)
                : [];
            const quarterValues = iQuarterVal >= 0
                ? [rows[iQuarterVal][1], rows[iQuarterVal][2], rows[iQuarterVal][3], rows[iQuarterVal][4]]
                : [];

            // Final capital charge
            const finalCapital = iFinalCap >= 0
                ? { label: c1(rows[iFinalCap]), val: rows[iFinalCap][5] }
                : null;

            setSheetData({
                pillar,
                nameOfRisk,
                summary,
                definition,
                definitionText,
                keyAreasIntro,
                keyAreas,
                riskMeasurement: {
                    heading,
                    intro,
                    tableTitle,
                    period,
                    indexHeaders,
                    indexRows: parsedIndexRows,
                    indexTotal,
                    gradeHeaders,
                    gradeRows: parsedGradeRows,
                    particularsRows,
                    quarterHeaders,
                    quarterValues,
                    finalCapital
                },
            });

            setExcelLoaded(true);

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setExcelLoaded(true);
        }
    };

    const restoreExcelValues = () => {
        setIndexRows(initialIndexRows.map(row => ({ ...row })));
        setGradeRows(initialGradeRows.map(row => ({ ...row })));
    };

    const handleIndexChange = (rowIndex, field, value) => {
        const updatedRows = [...indexRows];

        updatedRows[rowIndex][field] = value;

        const weight = Number(updatedRows[rowIndex].weight) || 0;
        const observations = Number(updatedRows[rowIndex].observations) || 0;
        const impact = Number(updatedRows[rowIndex].impact) || 0;

        updatedRows[rowIndex].index = weight * observations * impact;

        setIndexRows(updatedRows);
    };

    const totalWeight = indexRows.reduce(
        (sum, row) => sum + (Number(row.weight) || 0),
        0
    );

    const totalIndex = indexRows.reduce(
        (sum, row) => sum + (Number(row.index) || 0),
        0
    );

    const calculatedGradeRows = gradeRows.map((row) => ({
        ...row,
        applicablePercentage:
            totalIndex >= Number(row.min) &&
                totalIndex <= Number(row.max)
                ? Number(row.percentage)
                : 0
    }));

    const totalApplicablePercentage = calculatedGradeRows.reduce(
        (sum, row) => sum + (Number(row.applicablePercentage) || 0),
        0
    );

    const capitalChargeForShariahRisk = Math.round(
        (Number(operationalRiskCharge) || 0) * totalApplicablePercentage
    );

    const getQuarterSequence = (selectedQuarter) => {
        if (!selectedQuarter) return [];

        const [q, yearStr] = selectedQuarter.split("-");
        const year = Number(yearStr);
        const quarter = Number(q.replace("Q", ""));

        const quarters = [];

        for (let i = 3; i >= 0; i--) {
            let currentQuarter = quarter - i;
            let currentYear = year;

            while (currentQuarter <= 0) {
                currentQuarter += 4;
                currentYear--;
            }

            quarters.push(`Q${currentQuarter}-${currentYear}`);
        }

        return quarters;
    };

    const displayedQuarterHeaders = getQuarterSequence(reportingDate);

    const getQuarterFromDate = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = d.getMonth() + 1;

        if (month <= 3) return `Q1-${year}`;
        if (month <= 6) return `Q2-${year}`;
        if (month <= 9) return `Q3-${year}`;
        return `Q4-${year}`;
    };

    const dataMap = {};

    liveData.forEach(item => {
        const quarter = getQuarterFromDate(item.reporting_date);

        dataMap[`${item.key_areas}_${quarter}`] = item;
    });

    const getQuarterValues = (selectedQuarter, keyArea) => {

        const quarters = getQuarterSequence(selectedQuarter);

        return quarters.map(q => {

            const record = dataMap[`${keyArea}_${q}`];

            return record
                ? record.final_capital_charge_for_quarter4_average_of_4_quarters
                : "";
        });

    };

    const values = getQuarterValues(reportingDate, "Shariah Committee Matters");

    const q4 = capitalChargeForShariahRisk;

    const finalCapitalCharge = Math.round(
        (
            (Number(values[0]) || 0) +
            (Number(values[1]) || 0) +
            (Number(values[2]) || 0) +
            (Number(q4) || 0)
        ) / 4
    );

    const formatPercentTwoDecimal = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(2)}%`;
    };

    const formatPercent = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatExcelPercent = (value) => {
        if (value === "" || value == null) return "";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatApplicablePercent = (value) => {
        return `${(Number(value || 0) * 100).toFixed(2)}%`;
    };

    const formatIndex = (value) => {
        if (value === "" || value == null) return "";

        return Number(value).toLocaleString("en-US", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2,
        });
    };

    const handleReset = () => {
        setOperationalRiskCharge("");
        setQ1("");
        setQ2("");
        setQ3("");

        const resetRows = indexRows.map(row => ({
            ...row,
            observations: "",
            impact: "",
            index: 0
        }));

        setIndexRows(resetRows);
    };

    const getReportingDate = (quarter) => {
        if (!quarter) return "";

        const [q, year] = quarter.split("-");

        switch (q) {
            case "Q1":
                return `${year}-03-31`;
            case "Q2":
                return `${year}-06-30`;
            case "Q3":
                return `${year}-09-30`;
            case "Q4":
                return `${year}-12-31`;
            default:
                return "";
        }
    };

    const generateTxtData = () => {
        const reportDate = getReportingDate(reportingDate);

        const lines = [];

        const particulars = sheetData.riskMeasurement.particularsRows;

        for (let i = 0; i < indexRows.length; i++) {

            const idx = indexRows[i];
            const grade = calculatedGradeRows[i] || {};

            let particularLabel = "";
            let particularValue = "";

            let quarter1 = "\\N";
            let quarter2 = "\\N";
            let quarter3 = "\\N";
            let quarter4 = "\\N";
            let average = "\\N";

            // First three Particular rows only
            if (i === 0) {
                particularLabel = particulars[0]?.label || "";
                particularValue = operationalRiskCharge;

                quarter1 = q1 || "\\N";
                quarter2 = q2 || "\\N";
                quarter3 = q3 || "\\N";
                quarter4 = q4 || "\\N";
                average = finalCapitalCharge || "\\N";
            }
            else if (i === 1) {
                particularLabel = particulars[1]?.label || "";
                particularValue = formatApplicablePercent(totalApplicablePercentage);
            }
            else if (i === 2) {
                particularLabel = particulars[2]?.label || "";
                particularValue = capitalChargeForShariahRisk;
            }

            lines.push([
                reportDate,
                idx.keyArea,
                formatPercent(idx.weight),
                idx.observations || "",
                idx.impact || "",
                Number(idx.index).toFixed(2),
                grade.scoreGrade || "",
                grade.min ?? "\\N",
                grade.max ?? "\\N",
                grade.percentage ? formatExcelPercent(grade.percentage) : "",
                formatApplicablePercent(grade.applicablePercentage),
                particularLabel,
                particularValue,
                quarter1,
                quarter2,
                quarter3,
                quarter4,
                average
            ].join("|"));
        }

        // Total Row
        lines.push([
            reportDate,
            "",
            formatPercent(totalWeight),
            "",
            "",
            Number(totalIndex).toFixed(2),
            "",
            "\\N",
            "\\N",
            "",
            "",
            "",
            "",
            "\\N",
            "\\N",
            "\\N",
            "\\N",
            "\\N"
        ].join("|"));

        return lines.join("\n");
    };

    const getQuarterFromReportingDate = (date) => {

        if (!date) return "";

        const [year, month] = date.split("-");

        switch (month) {
            case "03":
                return `Q1-${year}`;
            case "06":
                return `Q2-${year}`;
            case "09":
                return `Q3-${year}`;
            case "12":
                return `Q4-${year}`;
            default:
                return "";
        }
    };

    const rejectColumns = [
        "reporting_date",
        "quarter4",
        "quarter3",
        "quarter2",
        "quarter1",
        "no_of_observations_issues_non_compliance_delays_self_assesment_b",
        "impact_scale_of_1_to_10_c",
        "amount"
    ];

    const handleBulkReject = () => {

        setSelectedColumn("");
        setOtherReason("");

        setShowRejectModal(true);
    };

    const handleColumnSelect = (e) => {

        setSelectedColumn(e.target.value);

        if (e.target.value !== "Others") {
            setOtherReason("");
        }
    };

    const handleOtherReasonChange = (e) => {
        setOtherReason(e.target.value);
    };

    const formatColumnLabel = (column) => {
        return column
            .replace(/_/g, " ")
            .replace(/\b\w/g, c => c.toUpperCase());
    };

    const isReasonRequired = selectedColumn === "Others";

    const isSubmitDisabled =
        !selectedColumn ||
        (isReasonRequired && !otherReason.trim());

    const handleReasonSubmit = () => {

        if (!selectedColumn) {

            setMessageType("warning");
            setModalMessage("Please select rejection reason.");
            setShowModal(true);

            return;
        }

        if (selectedColumn === "Others" && !otherReason.trim()) {

            setMessageType("warning");
            setModalMessage("Please enter rejection reason.");
            setShowModal(true);

            return;
        }

        let reason = "";

        if (selectedColumn === "DeleteRecord") {

            reason = otherReason.trim()
                ? otherReason.trim()
                : "Delete the record";

        }
        else if (selectedColumn === "Others") {

            reason = otherReason.trim();

        }
        else {

            reason = otherReason.trim()
                ? `${formatColumnLabel(selectedColumn)} is not correct : ${otherReason}`
                : `${formatColumnLabel(selectedColumn)} is not correct`;

        }

        setRejectedReason(reason);

        setShowRejectModal(false);

        callRejectApi(reason);

    };

    const createStatusJson = async (
        reportingDate,
        status,
        fileType
    ) => {

        const today = new Date().toISOString().split("T")[0];
        const userId = localStorage.getItem("userid");

        const tableNameWithJson = `10192_submit.json`;

        let statusData = [];

        try {
            const response = await fetch(`/jsonfiles/${tableNameWithJson}`);

            if (response.ok) {
                statusData = await response.json();
            }
        } catch (err) {
            console.log("No existing status file. Creating new one.");
        }

        const newStatus = {
            reporting_date: reportingDate,
            submitted_date: today,
            status,
            reported_by: "10192",
            reviewed_by: "10007"
        };

        // Remove only the same reporting date
        const index = statusData.findIndex(
            item => item.reporting_date === reportingDate
        );

        if (index !== -1) {
            statusData.splice(index, 1);
        }

        // Latest entry always first
        statusData.unshift(newStatus);

        await axios.post(
            updatetextfile3001,
            {
                tableNameWithJson,
                content: JSON.stringify(statusData, null, 2)
            },
            {
                headers: {
                    userId,
                    "x-csrf-token": csrfToken
                },
                withCredentials: true
            }
        );

        console.log(`${tableNameWithJson} updated successfully`);
    };

    const callRejectApi = async (reason) => {

        const reportDate = getReportingDate(reportingDate);

        const selectedRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        const rowIds = selectedRecords.map(row => row.rowId);
        console.log("Row IDs:", rowIds);
        // console.log("First Row ID:", rowIds[0]);

        try {

            const config = {

                headers: {

                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,

                },

                withCredentials: true,

                params: {
                    // rowId: rowIds,
                    tableName: "shariah_pillar1",
                    status: 0,
                    dataModel: "BDM",
                    rejectedReason: reason,
                    "Notifications": "IN",
                    isBulk: 1,
                    dept: department

                }
            };

            const response = await axios.post(
                checkboxrejectpastdata,
                rowIds,   // <-- Send row IDs in the request body
                config
            );

            console.log("Row IDs1:", rowIds);
            // console.log("First Row ID:", rowIds[0]);
            console.log(response.data);

            if (response.data?.message === "Past Data Rejected") {

                setMessageType("success");
                setModalMessage(response.data.message || "Rejected Successfully");

                await createStatusJson(
                    reportDate,
                    "Pending for Maker Modification",
                    "reject"
                );

                await fetchPreviewData();

                setReportingDate("");
                setMakerRemarks("");
                handleReset();
                setIsViewMode(false);

                setShowDownload(false);   // <-- Hide download

            } else {

                setMessageType("error");
                setModalMessage(response.data.message || "Reject Failed");

            }

            setShowModal(true);
        }
        catch (error) {

            console.log(error);

            setMessageType("error");

            setModalMessage(

                error.response?.data?.message ||

                "Error while rejecting."

            );

            setShowModal(true);

        }

    };

    const handleBulkApprove = async () => {

        setShowConfirmApprove(false);

        const reportDate = getReportingDate(reportingDate);

        const selectedRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        const rowIds = selectedRecords.map(row => row.rowId);

        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    tableName: "shariah_pillar1",
                    status: 1,
                    dataModel: "BDM",
                    Notifications: "IN",
                    isBulk: 1,
                    dept: department,
                },
            };

            const response = await axios.post(
                checkboxapprove,   // <-- Bulk approve checkbox API
                rowIds,            // <-- Send row IDs in request body
                config
            );

            console.log(response.data);

            if (response.data?.message === "Data Approved") {

                setMessageType("success");
                setModalMessage(response.data.message || "Approved Successfully");

                await createStatusJson(
                    reportDate,
                    "Data Approved",
                    "approve"
                );
                await fetchPreviewData();

                setShowDownload(true);   // <-- Show Download button


            } else {

                setMessageType("error");
                setModalMessage(response.data.message || "Approval Failed");

            }

            setShowModal(true);

        } catch (error) {

            console.log(error);

            setMessageType("error");
            setModalMessage(
                error.response?.data?.message ||
                "Error while approving."
            );

            setShowModal(true);
        }
    };

    const getFinalCapitalLabel = (selectedQuarter) => {
        if (!selectedQuarter)
            return "Final Capital Charge (Average of 4 Quarters)";

        const [q, year] = selectedQuarter.split("-");

        const quarterEndDates = {
            Q1: `31-MAR-${year}`,
            Q2: `30-JUN-${year}`,
            Q3: `30-SEP-${year}`,
            Q4: `31-DEC-${year}`
        };

        return `Final Capital Charge for ${quarterEndDates[q]} (Average of 4 Quarters)`;
    };

    const handleDownload = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Shariah Risk");

        // -----------------------------
        // Styles
        // -----------------------------
        const headerStyle = {
            font: {
                bold: true,
                color: { argb: "FFFFFFFF" },
            },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "1F4E78" },
            },
            alignment: {
                horizontal: "center",
                vertical: "middle",
                wrapText: true,
            },
            border: {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            },
        };

        const borderStyle = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
        };

        const totalStyle = {
            font: {
                bold: true,
            },
            fill: {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "D9D9D9" },
            },
            border: borderStyle,
        };

        // -----------------------------
        // Column Widths
        // -----------------------------
        worksheet.columns = [
            { width: 40 },
            { width: 18 },
            { width: 22 },
            { width: 18 },
            { width: 22 },
        ];

        // -----------------------------
        // Title
        // -----------------------------
        worksheet.mergeCells("A1:E1");

        const title = worksheet.getCell("A1");
        title.value = "Shariah Risk Measurement";
        title.font = {
            bold: true,
            size: 16,
        };
        title.alignment = {
            horizontal: "center",
        };

        worksheet.addRow([]);

        worksheet.addRow(["Reporting Date", reportingDate]);

        worksheet.addRow([]);

        // ===================================================
        // STATIC INFORMATION
        // ===================================================

        // 1. Name of Risk
        if (sheetData.nameOfRisk) {
            let row = worksheet.addRow(["1. Name of Risk"]);
            row.getCell(1).font = { bold: true, color: { argb: "1F4E78" } };

            row = worksheet.addRow([sheetData.nameOfRisk]);
            worksheet.addRow([]);
        }

        // 2. Summary
        if (sheetData.summary) {

            // Heading
            let row = worksheet.addRow(["2. Summary"]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" }
            };

            // Summary text
            row = worksheet.addRow([sheetData.summary]);

            worksheet.mergeCells(`A${row.number}:E${row.number}`);
            console.log(worksheet.getCell(`A${row.number}`).isMerged);

            row.getCell(1).alignment = {
                wrapText: true,
                horizontal: "left",
                vertical: "top",
            };

            worksheet.addRow([]);
        }

        // 3. Definition
        if (sheetData.definition) {

            // Heading
            let row = worksheet.addRow([sheetData.definition]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Definition text
            row = worksheet.addRow([sheetData.definitionText]);

            // Merge across all columns
            worksheet.mergeCells(`A${row.number}:E${row.number}`);

            row.getCell(1).alignment = {
                wrapText: true,
                vertical: "top",
                horizontal: "left",
            };

            worksheet.addRow([]);
        }

        // 4. Key Areas of Risk
        if (sheetData.keyAreas.length > 0) {

            // Heading
            let row = worksheet.addRow(["3. Key Areas of Risk"]);
            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Intro
            if (sheetData.keyAreasIntro) {
                row = worksheet.addRow([sheetData.keyAreasIntro]);

                worksheet.mergeCells(`A${row.number}:E${row.number}`);

                row.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            }

            // Bullet points
            sheetData.keyAreas.forEach((area) => {

                const text =
                    typeof area === "string"
                        ? area
                        : JSON.stringify(area);

                const bulletRow = worksheet.addRow([`• ${text}`]);

                worksheet.mergeCells(`A${bulletRow.number}:E${bulletRow.number}`);

                bulletRow.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            });

            worksheet.addRow([]);
        }

        // 5. Risk Measurement
        // 5. Risk Measurement
        if (sheetData.riskMeasurement.heading) {

            // Heading
            let row = worksheet.addRow([
                `4. ${sheetData.riskMeasurement.heading}`,
            ]);

            row.getCell(1).font = {
                bold: true,
                color: { argb: "1F4E78" },
            };

            // Intro
            if (sheetData.riskMeasurement.intro) {
                row = worksheet.addRow([
                    sheetData.riskMeasurement.intro,
                ]);

                // Merge across all columns
                worksheet.mergeCells(`A${row.number}:E${row.number}`);

                row.getCell(1).alignment = {
                    wrapText: true,
                    vertical: "top",
                    horizontal: "left",
                };
            }

            worksheet.addRow([]);
        }

        // ===================================================
        // TABLE 1
        // ===================================================

        const header1 = worksheet.addRow([
            "Key Area",
            "Weight (A)",
            "No. of Observations (B)",
            "Impact (C)",
            "Shariah Risk Index",
        ]);

        header1.eachCell((cell) => {
            Object.assign(cell, {
                style: headerStyle,
            });
        });

        indexRows.forEach((r) => {
            const row = worksheet.addRow([
                r.keyArea,
                Number(r.weight),
                Number(r.observations),
                Number(r.impact),
                r.index,
            ]);

            // Format Weight column as percentage
            row.getCell(2).numFmt = "0.00%";

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        const totalRow = worksheet.addRow([
            "",
            Number(totalWeight),
            "",
            "",
            totalIndex,
        ]);

        // Format Total Weight as percentage
        totalRow.getCell(2).numFmt = "0.00%";

        totalRow.eachCell((cell) => {
            cell.font = totalStyle.font;
            cell.fill = totalStyle.fill;
            cell.border = totalStyle.border;
        });

        totalRow.getCell(2).numFmt = "0%";      // or "0.00%"

        worksheet.addRow([]);

        // ===================================================
        // TABLE 2
        // ===================================================

        const header2 = worksheet.addRow([
            "Score Grade",
            "Min",
            "Max",
            "%",
            "Applicable %",
        ]);

        header2.eachCell((cell) => {
            cell.style = headerStyle;
        });

        calculatedGradeRows.forEach((r) => {
            const row = worksheet.addRow([
                r.scoreGrade,
                r.min,
                r.max,
                Number(r.percentage),
                Number(r.applicablePercentage),
            ]);

            row.getCell(4).numFmt = "0.00%";
            row.getCell(5).numFmt = "0.00%";

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        worksheet.addRow([]);

        // ===================================================
        // TABLE 3
        // ===================================================

        const header3 = worksheet.addRow([
            "Particulars",
            "Amount",
        ]);

        header3.eachCell((cell) => {
            cell.style = headerStyle;
        });

        [
            [
                "Operational Risk Pillar I Capital Charge",
                Number(operationalRiskCharge),
            ],
            [
                "Applicable % Capital Charge for Shariah Risk",
                totalApplicablePercentage,
            ],
            [
                "Capital Charge for Shariah Risk",
                capitalChargeForShariahRisk,
            ],
        ].forEach((item) => {
            const row = worksheet.addRow(item);

            // Apply percentage format only to the Applicable % row
            if (item[0] === "Applicable % Capital Charge for Shariah Risk") {
                row.getCell(2).numFmt = "0.00%";
            }

            row.eachCell((cell) => {
                cell.border = borderStyle;
            });
        });

        worksheet.addRow([]);

        // ===================================================
        // TABLE 4
        // ===================================================

        const header4 = worksheet.addRow([
            "Q1-2025",
            "Q2-2025",
            "Q3-2025",
            "Q4-2025",
            "Q1-2026",
            "Q2-2026",
            "Q3-2026",
            "Q4-2026",
            "Q1-2027",
        ]);

        header4.eachCell((cell) => {
            cell.style = headerStyle;
        });

        const quarterRow = worksheet.addRow([
            Number(q1),
            Number(q2),
            Number(q3),
            q4,
        ]);

        quarterRow.eachCell((cell) => {
            cell.border = borderStyle;
        });

        worksheet.addRow([]);

        // ===================================================
        // FINAL CAPITAL
        // ===================================================

        worksheet.mergeCells(`A${worksheet.rowCount + 1}:D${worksheet.rowCount + 1}`);

        const finalRow = worksheet.getRow(worksheet.rowCount + 1);

        finalRow.getCell(1).value = getFinalCapitalLabel(reportingDate);
        finalRow.getCell(5).value = finalCapitalCharge;

        finalRow.eachCell((cell) => {
            cell.font = {
                bold: true,
                color: { argb: "FFFFFF" },
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "0D6EFD" },
            };

            cell.border = borderStyle;
        });

        // -----------------------------
        // Download
        // -----------------------------

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer]),
            `Shariah_Risk_${reportingDate}.xlsx`
        );
    };


    return (
        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >
            <Header />
            <Navigation />
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            {/* <div className="container-fluid mt-3 mb-4"> */}
                            {loading ? (
                                <div className="text-center mt-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : !sheetData ? (
                                <div className="card">
                                    <div className="card-body text-center">No Data Found</div>
                                </div>
                            ) : (
                                <>
                                    {/* Page title */}
                                    {/* <div className="card mb-3"> */}
                                    <div className="card-header bg-primary text-white">
                                        <h5 className="mb-0">
                                            {sheetData.nameOfRisk}
                                        </h5>
                                        {/* </div> */}
                                    </div>
                                    <div className="row g-2">

                                        {/* ── LEFT col: points 1–4 ── */}
                                        <div className="col-lg-4 col-md-12">
                                            <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                                <div className="card-body">
                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "340px" }}>
                                                        <div className="">
                                                            <GapsyShariahDescription />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* ── RIGHT col: tables ── */}
                                        <div className="col-lg-8 col-md-12">
                                            <div className="card h-100 shadow-sm">
                                                {/* <div className={`tableWrapperLarge ${tableStyles.tableWrapperLarge}`}> */}
                                                <div className="card-body">
                                                    <div className={`tableWrapper ${tableStyles.tableWrapper}`} style={{ maxHeight: "340px" }}>
                                                        <div className="table-on-homepage-only">
                                                            <div className="p-3">

                                                                {sheetData.riskMeasurement.tableTitle && (
                                                                    <div className="px-2 pt-2 mb-3">
                                                                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                                            <h6 className="fw-bold text-primary mb-0">
                                                                                {sheetData.riskMeasurement.tableTitle}
                                                                            </h6>

                                                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                                                <label
                                                                                    htmlFor="reportingDate"
                                                                                    className="fw-semibold mb-0 text-nowrap"
                                                                                >
                                                                                    Reporting Date
                                                                                </label>

                                                                                <select
                                                                                    id="reportingDate"
                                                                                    className="form-select form-select-sm"
                                                                                    style={{ width: "150px" }}
                                                                                    value={reportingDate}
                                                                                    onChange={(e) => {
                                                                                        const value = e.target.value;
                                                                                        setReportingDate(value);
                                                                                        loadReportingDateData(value);
                                                                                    }}
                                                                                >
                                                                                    <option value="">Select</option>

                                                                                    {reportingDates.map((item) => (
                                                                                        <option key={item} value={item}>
                                                                                            {item}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                                {/* )} */}

                                                                                {!isNullValue(makerRemarks) && (
                                                                                    <>
                                                                                        <label className="fw-semibold mb-0 text-nowrap">
                                                                                            Remarks
                                                                                        </label>

                                                                                        <span
                                                                                            className="text-danger fw-semibold"
                                                                                            style={{ maxWidth: "350px", wordBreak: "break-word" }}
                                                                                        >
                                                                                            {makerRemarks}
                                                                                        </span>
                                                                                    </>
                                                                                )}

                                                                                {showDownload && (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-success btn-sm"
                                                                                        disabled={!reportingDate}
                                                                                        onClick={handleDownload}
                                                                                    >
                                                                                        <i className="bi bi-download me-1"></i>
                                                                                        Download
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Table 1: Shariah Risk Index */}
                                                                {sheetData.riskMeasurement.indexHeaders.length > 0 && (

                                                                    // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                    <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                        <thead className="thead-light">
                                                                            <tr>
                                                                                {sheetData.riskMeasurement.indexHeaders.map((h, i) => (
                                                                                    <th
                                                                                        key={i}
                                                                                        style={{
                                                                                            whiteSpace: "normal",
                                                                                            lineHeight: "1.2",
                                                                                            verticalAlign: "middle",
                                                                                            textAlign: "center"
                                                                                        }}
                                                                                    >
                                                                                        {i === 2 ? (
                                                                                            <>
                                                                                                No. of.
                                                                                                <br />
                                                                                                Observations (B)
                                                                                            </>
                                                                                        ) : i === 3 ? (
                                                                                            <>
                                                                                                Impact
                                                                                                <br />
                                                                                                (Scale of 1 to 10) (C)
                                                                                            </>
                                                                                        ) : (
                                                                                            h
                                                                                        )}
                                                                                    </th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {indexRows.map((row, ri) => (
                                                                                <tr key={ri}>
                                                                                    <td>{row.keyArea}</td>

                                                                                    <td>{fmt(row.weight)}</td>

                                                                                    <td>
                                                                                        {isViewMode ? (
                                                                                            <div className="text-center px-2 py-1">
                                                                                                {row.observations}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <input
                                                                                                type="number"
                                                                                                className="form-control form-control-sm text-center"
                                                                                                value={row.observations}
                                                                                                onChange={(e) =>
                                                                                                    handleIndexChange(ri, "observations", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        )}
                                                                                    </td>

                                                                                    <td>
                                                                                        {isViewMode ? (
                                                                                            <div className="text-center px-2 py-1">
                                                                                                {row.impact}
                                                                                            </div>
                                                                                        ) : (
                                                                                            <input
                                                                                                type="number"
                                                                                                min="0"
                                                                                                className="form-control form-control-sm text-center"
                                                                                                value={row.impact}
                                                                                                onChange={(e) =>
                                                                                                    handleIndexChange(ri, "impact", e.target.value)
                                                                                                }
                                                                                            />
                                                                                        )}
                                                                                    </td>

                                                                                    {/* <td>{fmt(row.index)}</td> */}
                                                                                    <td>{formatIndex(row.index)}</td>
                                                                                </tr>
                                                                            ))}

                                                                            <tr className="fw-bold table-secondary">
                                                                                <td></td>
                                                                                {/* <td>{fmt(totalWeight)}</td> */}
                                                                                <td>{formatPercent(totalWeight)}</td>
                                                                                <td></td>
                                                                                <td></td>
                                                                                {/* <td>{fmt(totalIndex)}</td> */}
                                                                                <td>{formatIndex(totalIndex)}</td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    // </div>

                                                                )}

                                                                {/* Table 2: Score Grade */}
                                                                {sheetData.riskMeasurement.gradeHeaders.length > 0 && (

                                                                    // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                    <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                        <thead className="thead-light">
                                                                            <tr>
                                                                                {sheetData.riskMeasurement.gradeHeaders.map((h, i) => (
                                                                                    <th key={i}>{h}</th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {calculatedGradeRows.map((row, ri) => (
                                                                                <tr key={ri}>
                                                                                    <td>{row.scoreGrade}</td>
                                                                                    <td>{row.min}</td>
                                                                                    <td>{row.max}</td>

                                                                                    {/* Read from Excel as-is */}
                                                                                    <td>{formatExcelPercent(row.percentage)}</td>

                                                                                    {/* Calculated value */}
                                                                                    <td>{formatApplicablePercent(row.applicablePercentage)}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                    // </div>

                                                                )}

                                                                {/* Table 3: Particulars */}
                                                                {sheetData.riskMeasurement.particularsRows.length > 0 && (

                                                                    // <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                                    <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                                        <thead className="thead-light">
                                                                            <tr>
                                                                                <th>Particulars</th>
                                                                                <th>Amount</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {sheetData.riskMeasurement.particularsRows.map((row, ri) => (
                                                                                <tr key={ri}>
                                                                                    <td className="text-start">{row.label}</td>

                                                                                    <td>
                                                                                        {ri === 0 ? (
                                                                                            isViewMode ? (
                                                                                                <div className="text-center px-2 py-1">
                                                                                                    {operationalRiskCharge}
                                                                                                </div>
                                                                                            ) : (
                                                                                                <input
                                                                                                    type="number"
                                                                                                    className="form-control form-control-sm text-center"
                                                                                                    value={operationalRiskCharge}
                                                                                                    onChange={(e) => setOperationalRiskCharge(e.target.value)}
                                                                                                />
                                                                                            )
                                                                                        ) : ri === 1 ? (
                                                                                            formatPercentTwoDecimal(totalApplicablePercentage)
                                                                                        ) : (
                                                                                            fmt(capitalChargeForShariahRisk)
                                                                                        )}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                    // </div>

                                                                )}

                                                                {/* Table 4: Quarterly Capital Charges */}
                                                                {sheetData.riskMeasurement.quarterHeaders.length > 0 && (
                                                                    
                                                                    <table className="table table-bordered table-hover text-center">
                                                                        <thead>
                                                                            <tr>
                                                                                {displayedQuarterHeaders.map((h, i) => (
                                                                                    <th key={i}>{h}</th>
                                                                                ))}
                                                                            </tr>
                                                                        </thead>

                                                                        <tbody>
                                                                            <tr>
                                                                                {values.map((value, index) => {
                                                                                    const displayValue =
                                                                                        value === "" || value === null || value === undefined
                                                                                            ? 0
                                                                                            : fmt(value);

                                                                                    return (
                                                                                        <td key={index} className="text-end">
                                                                                            {index === 3 ? fmt(q4) : displayValue}
                                                                                        </td>
                                                                                    );
                                                                                })}
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    // </div>
                                                                    // </div>
                                                                )}

                                                                {/* Final Capital Charge */}
                                                                {sheetData.riskMeasurement.finalCapital && (
                                                                    <div className="mx-2 mt-3 mb-2">
                                                                        <div className="alert alert-primary d-flex justify-content-between align-items-center mb-0 py-2">
                                                                            <span className="fw-semibold" style={{ fontSize: "0.9rem" }}>
                                                                                {getFinalCapitalLabel(reportingDate)}
                                                                            </span>
                                                                            <span className="fw-bold fs-6">
                                                                                {fmt(finalCapitalCharge)}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* </div> */}

                                                <div className="d-flex justify-content-end gap-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-light btn-sm custom-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="Left"
                                                        title="Click to Reject"
                                                        style={{
                                                            ...Rejectcolor,
                                                            color: 'white',
                                                            marginLeft: '10px'
                                                        }}
                                                        onClick={handleBulkReject}
                                                    >
                                                        Reject
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            <Modal show={showConfirmApprove} onHide={() => setShowConfirmApprove(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>Confirm Approval</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    <p>Are you sure you want to Approve this record?</p>
                                </Modal.Body >
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="secondary"
                                        style={
                                            cancelButtonStyle
                                        } onClick={() => setShowConfirmApprove(false)}>Cancel</Button>
                                    <Button
                                        variant="Primary"
                                        style={submitButtonStyle}
                                        onClick={() => {
                                            setShowConfirmApprove(false);
                                            handleBulkApprove();
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={showModal}
                                onHide={handleCancel}
                                style={{ marginTop: '12vh' }}
                            >
                                <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                    style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green' }}>✅</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                marginBottom: '0px',
                                                color: messageType === 'success' ? 'green' : 'red',
                                                fontSize: '14px',
                                                whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: modalMessage.replace(/\n/g, '<br />')
                                            }}
                                        ></p>



                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                        onClick={handleCancel}>
                                    </button>

                                </div>
                            </Modal>
                            <Modal
                                show={showRejectModal}
                                onHide={() => setShowRejectModal(false)}
                                backdrop="static"
                                keyboard={false}
                                size="lg"
                                style={{ marginTop: '12vh' }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>Reason for Rejection</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    <div className="form-group">
                                        <label htmlFor="column-select" className="text-secondary">Select Reason</label>

                                        <select
                                            className="form-control"
                                            id="column-select"
                                            onChange={handleColumnSelect}
                                            value={selectedColumn}
                                        >
                                            <option value="">Select Reason</option>

                                            {rejectColumns
                                                .filter(column => column !== "Maker_Remarks")
                                                .map((column, index) => (
                                                    <option key={index} value={column}>
                                                        {formatColumnLabel(column)} is not correct
                                                    </option>
                                                ))}

                                            <option value="DeleteRecord">Delete the record</option>
                                            <option value="Others">Others</option>
                                        </select>

                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="other-reason" className="text-secondary">Reason Details</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="reason-input"
                                            id="other-reason"
                                            value={otherReason}
                                            onChange={handleOtherReasonChange}
                                            placeholder="Provide Reason here..."
                                            required={isReasonRequired}
                                        />
                                    </div>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button
                                        variant="secondary"
                                        onClick={() => setShowRejectModal(false)}
                                        style={cancelButtonStyle}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onClick={handleReasonSubmit}
                                        disabled={isSubmitDisabled}

                                        style={
                                            ProceedButtonStyle
                                        }
                                    >
                                        Proceed
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                          
                            <Modal
                                show={showReportingModal}
                                onHide={() => {
                                    setShowReportingModal(false);
                                    setReportingDate("");
                                    setAllowSubmit(false);
                                }}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: "12vh" }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>
                                        Reporting Date Validation
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    {reportingMessage}
                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button
                                        variant="Primary"
                                        style={
                                            submitButtonStyle
                                        }
                                        onClick={() => {
                                            setShowReportingModal(false);
                                            setReportingDate("");
                                            setAllowSubmit(false);
                                            restoreExcelValues();
                                        }}
                                    >
                                        OK
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyShariahReviewRetrieval;